/** Compare payment and net sale total at the currency's two-decimal precision. */
export function validateSalePayment(status: unknown, amountPaid: unknown, total: number): string {
  const paid = Number(amountPaid);
  if (!Number.isFinite(paid) || paid < 0) return "Amount paid must be a valid, non-negative amount.";
  if (!Number.isFinite(total) || total < 0) return "The sale total is invalid.";
  const paidCents = Math.round((paid + Number.EPSILON) * 100);
  const totalCents = Math.round((total + Number.EPSILON) * 100);
  if (status === "Paid" && paidCents !== totalCents)
    return "For Paid sales, amount paid must equal the total after discounts.";
  if (status === "PartiallyPaid" && (paidCents <= 0 || paidCents >= totalCents))
    return "For Partially paid sales, amount paid must be greater than zero and less than the total.";
  return "";
}
